/* AMZ Mirror slideshow — scroll-snap track + arrows/dots pill (sections/amz-mirror.liquid).
   Without JS the slides stay swipeable (native horizontal scroll); JS only adds the controls. */
(function () {
  function init(root) {
    if (root.getAttribute('data-amzm-ready')) return;
    root.setAttribute('data-amzm-ready', '1');
    var track = root.querySelector('.amzm-slider__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var dotsWrap = root.querySelector('[data-amzm-dots]');
    var prev = root.querySelector('[data-amzm-prev]');
    var next = root.querySelector('[data-amzm-next]');
    var dots = slides.map(function (s, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'amzm-slider__dot';
      d.setAttribute('aria-label', 'Slide ' + (i + 1) + ' din ' + slides.length);
      d.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(d);
      return d;
    });
    var current = 0;
    /* stacked layout (< 990px): slides have different text lengths → track follows the current slide height */
    function fit() {
      if (window.innerWidth < 990) track.style.height = slides[current].offsetHeight + 'px';
      else track.style.height = '';
    }
    function mark(i) {
      current = i;
      fit();
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      slides.forEach(function (s, j) { if (j === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
    }
    function go(i) {
      var n = slides.length;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    prev.addEventListener('click', function () { go(current - 1); });
    next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current && i >= 0 && i < slides.length) mark(i);
      }, 80);
    }, { passive: true });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 120); });
    window.addEventListener('load', fit);
    mark(0);
    root.classList.add('is-ready');
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-amzm-slider]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
